import { useState } from 'react';
import { restaurantsAPI } from '../lib/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Link as LinkIcon, Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export default function RestaurantLinks({ restaurantId, links = [], canEdit, onSaved }) {
  const [label, setLabel] = useState('');
  const [url, setUrl] = useState('');
  const [saving, setSaving] = useState(false);

  const persist = async (next) => {
    setSaving(true);
    try {
      await restaurantsAPI.update(restaurantId, { links: next });
      onSaved?.();
    } catch (err) {
      toast.error('Failed to save links');
    } finally {
      setSaving(false);
    }
  };

  const addLink = async () => {
    if (!url.trim()) { toast.error('URL is required'); return; }
    const next = [...links, { id: crypto.randomUUID(), label: label.trim() || url.trim(), url: url.trim() }];
    setLabel('');
    setUrl('');
    await persist(next);
  };

  const removeLink = async (id) => {
    await persist(links.filter(l => l.id !== id));
  };

  return (
    <div className="bg-white border border-[#E0E0E0] rounded-lg p-4" data-testid="restaurant-links">
      <h3 className="font-semibold text-[#111111] mb-3">Links</h3>
      {links.length === 0 && <p className="text-sm text-[#999999]">No links yet.</p>}
      <div className="space-y-1">
        {links.map(l => (
          <div key={l.id} className="flex items-center justify-between bg-[#F5F5F5] rounded px-2 py-1.5" data-testid={`restaurant-link-${l.id}`}>
            <a href={l.url} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-sm text-[#111111] hover:text-[#FF6B35] truncate">
              <LinkIcon size={13} className="flex-shrink-0" />
              <span className="truncate">{l.label}</span>
            </a>
            {canEdit && (
              <button onClick={() => removeLink(l.id)} className="text-[#999999] hover:text-[#DC2626]" data-testid={`remove-link-${l.id}`}>
                <Trash2 size={14} />
              </button>
            )}
          </div>
        ))}
      </div>
      {canEdit && (
        <div className="flex flex-col sm:flex-row gap-2 mt-3">
          <Input value={label} onChange={e => setLabel(e.target.value)} placeholder="Label (optional)" className="sm:w-40" data-testid="link-label-input" />
          <Input value={url} onChange={e => setUrl(e.target.value)} placeholder="https://..." data-testid="link-url-input" />
          <Button variant="outline" onClick={addLink} disabled={saving} data-testid="add-link-btn">
            <Plus size={16} />
          </Button>
        </div>
      )}
    </div>
  );
}
